import { useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import NewBookingDuck from 'ducks/new-booking-duck';
import { getDeliveriesInsuranceOptions } from 'helper/insurance';

const useInsuranceHook = (deliveryIDs, deliveries) => {
  const dispatch = useDispatch();

  const onChange = useCallback(
    (insuranceOptionID, dropOff) => {
      dispatch(
        NewBookingDuck.creators.updateDeliveryGuarantee(
          deliveryIDs,
          dropOff,
          insuranceOptionID,
        ),
      );
    },
    [dispatch, deliveryIDs],
  );

  const onResetAll = useCallback(() => onChange(undefined, undefined), [
    onChange,
  ]);

  const deliveriesInsuranceDetails = useMemo(
    () => getDeliveriesInsuranceOptions(deliveries),
    [deliveries],
  );

  return {
    onChange,
    onResetAll,
    deliveriesInsuranceDetails,
  };
};

export default useInsuranceHook;
